import { STAGES, stageFromBackend } from './stage'

// GraphQL-API pro Stage. Die CDK-API (Stack Aivy-<stage>-Data im
// aivy-backend-app, Output awsAppsyncApiEndpoint) hat dasselbe Schema, dieselben
// Tabellen und denselben User Pool wie die Gen-1-API. Stages ohne Eintrag
// bleiben auf der Gen-1-API aus aws-exports.js. Zurück auf Gen 1: Eintrag
// entfernen.
export const CDK_GRAPHQL_ENDPOINTS = {
  [STAGES.DEVELOP]:
    'https://dsngt345fzblppniowfqhfq22a.appsync-api.eu-central-1.amazonaws.com/graphql',
  [STAGES.STAGING]:
    'https://dgkmud5olngijjtcry35cj2a3i.appsync-api.eu-central-1.amazonaws.com/graphql',
  [STAGES.PRODUCTION]:
    'https://iwizynmgivfppehkwb2ieeku2e.appsync-api.eu-central-1.amazonaws.com/graphql'
}

/** aws-exports mit dem GraphQL-Endpunkt, den die Stage nutzen soll */
export const withGraphqlApi = (config) => {
  const endpoint = CDK_GRAPHQL_ENDPOINTS[stageFromBackend(config)]
  if (!endpoint) return config
  return { ...config, aws_appsync_graphqlEndpoint: endpoint }
}
